import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    makeStyles,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { closeEditItemsDialog } from "./items-edit-slice";
import { db } from "../../../../firebase";
import { useEffect, useState } from "react";
import { editItemsService, getItemTypesListService, getItemStatusListService, getItemCategoriesListService } from "./items-edit-service";
import { showErrorSnackbar } from "../../../shared/snackbar/snackbar-slice";

const useStyles = makeStyles((theme) => ({
    button: {
        background: "#111111",
        color: "#fbbbd3",
        '&:hover': {
            backgroundColor: '#fbbbd3',
            color: '#111111',
        },
    },
    buttonText: {
        color: "#111111",
        '&:hover': {
            backgroundColor: '#fbbbd3',
            color: '#111111',
        },
    },
    title: {
        background:"#111111",
    },
}));

const initiaFormData = {
    code: "",
    name: "",
    description: "",
    pieces: 0,
    original_price: 0,
    increase: 0,
    unit_price: 0,
    rent_price: 0,
    rent_percent: 0,
    deposit: 0,
    deposit_percent: 0,
    type: "",
    status: "",
    category: "",
};

const ItemsEdit = () => {
    const classes = useStyles();
    const itemsData = useSelector((state) => state.itemsEditSlice.itemsEdit);
    const showDialog = useSelector((state) => state.itemsEditSlice.showDialog);
    const isLoading = useSelector((state) => state.itemsEditSlice.isLoading);
    const itemTypesList = useSelector((state) => state.itemsEditSlice.itemTypesList);
    const itemStatusList = useSelector((state) => state.itemsEditSlice.itemStatusList);
    const itemCategoriesList = useSelector((state) => state.itemsEditSlice.itemCategoriesList);
    const [formData, setFormData ] = useState(initiaFormData);
    const [isSelectStatusDisabled, setIsSelectStatusDisabled ] = useState(true);
    const dispatch = useDispatch();

    const itemsId = itemsData.id;

    // get data
    useEffect(() => {
        if (showDialog) {
            const fetchItemTypesData = async () => {
                try {
                    await getItemTypesListService(dispatch, db, "item_types");
                } catch(e) {
                    dispatch(showErrorSnackbar("Something went wrong while trying to fetch item types."));
                    console.error("ItemsEdit fetchItemTypesData error: ", e);
                }
            };
            const fetchItemStatusData = async () => {
                try {
                    await getItemStatusListService(dispatch, db, "item_status");
                } catch(e) {
                    dispatch(showErrorSnackbar("Something went wrong while trying to fetch item status."));
                    console.error("ItemsEdit fetchItemStatusData error: ", e);
                }
            };
            const fetchItemCategoriesData = async () => {
                try {
                    await getItemCategoriesListService(dispatch, db, "item_categories");
                } catch(e) {
                    dispatch(showErrorSnackbar("Something went wrong while trying to fetch item categories."));
                    console.error("ItemsEdit fetchItemCategoriesData error: ", e);
                }
            };
            setFormData(itemsData);
            fetchItemTypesData();
            fetchItemStatusData();
            fetchItemCategoriesData();
        }
    }, [showDialog, itemsData, dispatch]);

    useEffect(() => {
        if (formData.type.length) {
            setIsSelectStatusDisabled(false);
        } else {
            setIsSelectStatusDisabled(true);
        }
    }, [formData.type]);

    // handle input
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
          ...formData,
          [name]: value
        });
    };

    // handle edit
    const handleEditSubmit = async (e) => {
        e.preventDefault();  
       
        try {
            await editItemsService(dispatch, db, "items", itemsId, formData);
            // window.location.reload();
        } catch (e) {
            console.error("ItemsEdit handleEditSubmit error: ", e);
        }

        handleEditClose();
    };

    // handle close edit
    const handleEditClose = () => {
        setFormData(initiaFormData);
        dispatch(closeEditItemsDialog());
    };

    return (
        <>
            <Dialog
                open={showDialog}
            >
                <DialogTitle className={classes.title}>
                    Edit Item
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                id="filled-basic"
                                label="Code"
                                variant="filled"
                                fullWidth
                                name="code"
                                value={formData.code}
                                onChange={handleInputChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                id="filled-basic"
                                label="Name"
                                variant="filled"
                                fullWidth
                                name="name"
                                value={formData.name}
                                onChange={handleInputChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                id="filled-basic"
                                label="Description"
                                variant="filled"
                                fullWidth
                                name="description"
                                value={formData.description}
                                onChange={handleInputChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                id="filled-basic"
                                label="Original Price"
                                variant="filled"
                                fullWidth
                                name="original_price"
                                value={formData.original_price}
                                onChange={handleInputChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl variant="filled" fullWidth>
                                <InputLabel id="type-select">Type</InputLabel>
                                <Select
                                    id="type-select-id"
                                    label="Type"
                                    labelId="type-select"
                                    onChange={handleInputChange}
                                    name="type"
                                    value={formData.type || ""}
                                    displayEmpty
                                    inputlabelprops={{
                                        shrink: true,
                                    }}
                                    // onBlur
                                >
                                    {itemTypesList.map((type) => (
                                        <MenuItem key={type.id} value={type.name}>
                                            {type.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl variant="filled" fullWidth>
                                <InputLabel id="status-select">Status</InputLabel>
                                <Select
                                    id="status-select-id"
                                    label="Status"
                                    labelId="status-select"
                                    onChange={handleInputChange}
                                    name="status"
                                    value={formData.status || ""}
                                    displayEmpty
                                    disabled={isSelectStatusDisabled}
                                    inputlabelprops={{
                                        shrink: true,
                                    }}
                                    // onBlur
                                >
                                    {itemStatusList.map((status) => {
                                        const isDisabled =
                                        formData.type === "For rent" ?
                                        (status.name === "Available" || status.name === "Out of stock")
                                        : (status.name === "Rented" || status.name === "Open for rent" || status.name === "Reserved");

                                        return (
                                        <MenuItem
                                            key={status.id}
                                            value={status.name}
                                            disabled={isDisabled}
                                        >
                                            {status.name}
                                        </MenuItem>
                                        );
                                    })}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl variant="filled" fullWidth>
                                <InputLabel id="type-select">Category</InputLabel>
                                <Select
                                    id="category-select-id"
                                    label="Category"
                                    labelId="category-select"
                                    onChange={handleInputChange}
                                    name="category"
                                    value={formData.category || ""}
                                    displayEmpty
                                    inputlabelprops={{
                                        shrink: true,
                                    }}
                                    // onBlur
                                >
                                    {itemCategoriesList.map((category) => (
                                        <MenuItem key={category.id} value={category.name}>
                                            {category.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        {
                            formData.type === "For rent" && (
                                <>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            id="filled-basic"
                                            label="Rent %"
                                            variant="filled"
                                            fullWidth
                                            name="rent_percent"
                                            value={formData.rent_percent}
                                            onChange={handleInputChange}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            id="filled-basic"
                                            label="Deposit %"
                                            variant="filled"
                                            fullWidth
                                            name="deposit_percent"
                                            value={formData.deposit_percent}
                                            onChange={handleInputChange}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </Grid>
                                </>
                            )
                        }
                        {
                            formData.type === "For sale" && (
                                <>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            id="filled-basic"
                                            label="Increase %"
                                            variant="filled"
                                            fullWidth
                                            name="increase"
                                            value={formData.increase}
                                            onChange={handleInputChange}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </Grid>
                                </>
                            )
                        }
                        <Grid item xs={12} sm={6}>
                            <TextField
                                id="filled-basic"
                                label="Piece(s)"
                                variant="filled"
                                fullWidth
                                name="pieces"
                                value={formData.pieces}
                                onChange={handleInputChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        className={classes.button}
                        onClick={handleEditSubmit}
                        disabled={isLoading}
                    >
                        {
                            isLoading ? (
                                "Saving..."
                            ) : (
                                "Save Changes"
                            )
                        }
                    </Button>
                    <Button
                        variant="text"
                        className={classes.buttonText}
                        onClick={handleEditClose}
                        disabled={isLoading}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default ItemsEdit;